// TEMPORARY compatibility file — Stripe stub (no real payments).

export async function getStripe() {
  // TODO: restore real Stripe.js init
  console.warn('[stripeConfig TEMP] getStripe() stub — payments disabled');
  return {
    redirectToCheckout: async () => ({
      error: { message: 'Stripe is not configured in this temporary build.' },
    }),
  };
}

export async function createCheckoutSession(_payload) {
  // TODO: restore real checkout session creation
  console.warn('[stripeConfig TEMP] createCheckoutSession() stub');
  return { sessionId: null, error: 'Stripe stub — no session created' };
}
